<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('vendas')">CheckList</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> {{ title }}
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="submit">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.idVenda" :error="form.errors.idVenda" class="pr-6  w-full lg:w-1/2" label="Nº Pedido" @change="getVenda" />
          <text-input v-model="form.vendedor" disabled :error="form.errors.vendedor" class="pr-6  w-full lg:w-1/2" label="Vendedor" />
          <div class="w-full py-4"><p class="font-medium">Informações da Empresa</p></div>
          <text-input v-model="form.cliente" disabled :error="form.errors.cliente" class="pr-6 pb-8 w-full lg:w-1/2" label="Razão Social" />
          <text-input v-model="form.cpfCnpj" disabled :mask="'##.###.###/####-##'" type="mask" :error="form.errors.cpfCnpj" class="pr-6 pb-8 w-full lg:w-1/2" label="CNPJ" />
          <text-input v-model="form.ramo" :error="form.errors.ramo" class="pr-6 pb-8 w-full lg:w-1/2" label="Atividade da Empresa" maxlength="100" />
          <text-input v-model="form.cidade" disabled :error="form.errors.cidade" class="pr-6 pb-8 w-full lg:w-1/2" label="Cidade" />
          <select-2-input v-model="form.responsavel" :get-option-label="option => option.razaoSocial" :options="responsaveis" :error="form.errors.responsavel" class="pr-6 pb-8 w-full lg:w-1/2" label="Responsável" @input="changeResponsavel" />
          <text-input v-model="form.contato" :mask="'+55 (##) #####-####'" type="mask" :error="form.errors.contato" class="pr-6 pb-8 w-full lg:w-1/2" label="Contato" />
          <text-input v-model="form.responsavelCpf" :mask="'###.###.###-##'" type="mask" :error="form.errors.responsavelCpf" class="pr-6 pb-8 w-full lg:w-1/2" label="CPF" />
          <text-input v-model="form.contador" :error="form.errors.contador" class="pr-6 pb-8 w-full lg:w-1/2" label="Contador" />
          <div class="w-full py-4"><p class="font-medium">Qual sistema será instalado?</p></div>
          <div v-if="form.errors.modulos" class="w-full"><p class="text-red-600">{{ form.errors.modulos }}</p></div>
          <checkbox v-for="modulo in modulos" :key="modulo.codModulo" class="pr-6 pb-8 w-full lg:w-2/6" :true-value="moduloIsChecked(modulo.codModulo)" :value="true" :label="modulo.descricao.toUpperCase()" @input="value => moduloCheck(modulo.codModulo, value)" />
          <div class="w-full py-4"><p class="font-medium">Especificações</p></div>
          <div v-if="form.errors.especificacoes" class="w-full"><p class="text-red-600">{{ form.errors.especificacoes }}</p></div>
          <checkbox v-for="especificacao in especificacoes" :key="especificacao.idEspecificacao" class="pr-6 pb-8 w-full" :true-value="especificacaoIsChecked(especificacao.idEspecificacao)" :value="true" :label="especificacao.descricao.toUpperCase()" @input="value => especificacaoCheck(especificacao.idEspecificacao, value)" />
          <div class="w-full py-4"><p class="font-medium">Outras especificações repassadas ou observadas</p></div>
          <textarea-input v-model="form.obs" class="w-full" />
        </div>

        <div v-if="editMode && setores.length > 0" class="flex flex-row px-8 py-4 space-x-2">
          <ApproveCheckList v-for="setorr in setores" :key="setorr.setor" :setor="setorr.setor" :status="setorr.status" />
        </div>

        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center space-x-2">
          <a v-if="editMode" title="Imprimir" class="px-2 flex items-center" :href="route('vendas.print', checklist.idCheck)" tabindex="-1" target="_blank">
            <icon name="printer" class="block w-6 h-6 fill-gray-400" />
          </a>
          <div class="flex-grow" />
          <button v-if="editMode && isOpen" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Apagar</button>
          <loading-button v-if="isOpen" :loading="form.processing" class="btn-indigo" type="submit"> {{ submitTextButton }}</loading-button>
          <button v-if="editMode && isApproved" type="button" :loading="form.processing" class="btn-success" @click="finish"> Finalizar </button>
          <button v-if="editMode && setor && !isDone && !isApproved" type="button" :loading="form.processing" class="btn-success" @click="approve('AP')"> Aprovar </button>
          <button v-if="editMode && setor && !isDone && !isApproved" type="button" :loading="form.processing" class="btn-danger" @click="approve('R')"> Rejeitar </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Checkbox from '../../Shared/Checkbox.vue'
import TextareaInput from '../../Shared/TextareaInput.vue'
import Select2Input from '../../Shared/Select2Input.vue'
import Icon from '../../Shared/Icon.vue'
import ApproveCheckList from '../../Shared/ApproveCheckList.vue'

export default {
  name: 'CreateOrEdit',
  metaInfo() {
    return { title: this.title }
  },
  components: {
    LoadingButton,
    TextInput,
    Checkbox,
    TextareaInput,
    Select2Input,
    Icon,
    ApproveCheckList,
  },
  layout: Layout,
  props: {
    checklist: {
      type: Object,
      default() {
        return {
          status: 'A',
        }
      },
    },
    modulos: {
      type: Array,
    },
    venda: {
      type: Object,
    },
    especificacoes: {
      type: Array,
    },
    responsaveis: {
      type: Array,
    },
    setor: {
      type: String,
    },
  },
  data() {
    return {
      show: false,
      imgDataUrl: '',
      form: this.$inertia.form({
        idCheck: null,
        idVenda: null,
        idVendedor: null,
        vendedor: null,
        cpfCnpj: null,
        idCliente: null,
        cliente: null,
        ramo: null,
        cidade: null,
        uf: null,
        codCidade: null,
        modulos: [],
        especificacoes: [],
        contato: null,
        responsavel: null,
        responsavelCpf: null,
        idResponsavel: null,
        obs: null,
        contador: null,
        idContador: null,
      }),
    }
  },
  computed: {
    title() {
      return this.checklist.idCheck ? 'Editar' : 'Criar'
    },
    editMode() {
      return this.checklist.idCheck ? true : false
    },
    submitTextButton() {
      return this.checklist.idCheck ? 'Atualizar' : 'Criar'
    },
    isOpen(){
      return this.checklist.status == 'A'
    },
    isDone(){
      return this.checklist.status == 'F'
    },
    isApproved(){
      return this.checklist.status == 'AP'
    },
    setores(){
      const retorno = []
      const desenvolvimento = this.checklist.especificacoes.some(row => row.especificacao?.desenvolvimento ==  'S')
      const comercial = this.checklist.especificacoes.some(row => row.especificacao?.comercial ==  'S')
      const implantacao = this.checklist.especificacoes.some(row => row.especificacao?.implantacao ==  'S')
      if(desenvolvimento){
        const  aprovamento = this.checklist.aprovamentos.find(row => row.tipo == 'D')
        retorno.push({setor:'Desenvolvimento', status: aprovamento ? aprovamento.status : null})
      }
      if(comercial){
        const  aprovamento = this.checklist.aprovamentos.find(row => row.tipo == 'C')
        retorno.push({setor:'Comercial', status: aprovamento ? aprovamento.status : null})
      }
      if(implantacao){
        const  aprovamento = this.checklist.aprovamentos.find(row => row.tipo == 'I')
        retorno.push({setor: 'Implantação', status: aprovamento ? aprovamento.status : null})
      }
      return retorno
    },
  },
  created(){
    if(this.editMode){
      this.form = {...this.form,
        ...this.checklist,
        modulos: this.checklist.modulos.map(e => e.codModulo),
        especificacoes: this.checklist.especificacoes.map(e => e.idEspecificacao),
      }
    }

  },
  remember: 'form',
  methods: {
    submit(){
      if(this.editMode){
        this.update()
      }else{
        this.store()
      }
    },
    store() {
      this.form.transform(data => {
        if(data.responsavel){
          data.responsavel = data.responsavel.razaoSocial
        }
        return data
      }).post(this.route('vendas.store'))
    },
    update() {
      this.form.transform(data => {
        if(data.responsavel){
          data.responsavel = data.responsavel.razaoSocial
        }
        return data
      }).put(this.route('vendas.update', this.checklist.idCheck))
    },
    destroy() {
      if (confirm('Você deseja mesmo apagar esse checklist?')) {
        this.$inertia.delete(this.route('vendas.destroy', this.checklist.idCheck))
      }
    },
    approve(status) {
      const setores = {
        'D': 'Desenvolvimento',
        'C': 'Comercial',
        'I': 'Implantação',
      }
      const labelByStatus = {
        'AP': 'Aprovando',
        'R': 'Rejeitando',
      }
      let msg = `Você está ${labelByStatus[status]} pelo setor ${setores[this.setor]}`
      if (confirm(msg)) {
        this.$inertia.post(this.route('vendas.approve', this.checklist.idCheck), {
          status,
          setores: this.setores,
        })
      }
    },
    finish() {
      if (confirm('Você deseja mesmo finalizar o checklist?')) {
        this.$inertia.put(this.route('vendas.finish', this.checklist.idCheck))
      }
    },
    getVenda({target}){
      this.$inertia.get(this.route('vendas.create'), {
        venda: target.value,
      }, { preserveState: true, onFinish: () => {
        this.loadVenda()
      },
      })
    },
    moduloCheck(codModulo){
      if(this.form.modulos.includes(codModulo)){
        this.form.modulos = this.form.modulos.filter(cod => cod != codModulo)
      }else{
        this.form.modulos.push(codModulo)
      }
    },
    especificacaoCheck(especificacao){
      if(this.form.especificacoes.includes(especificacao)){
        this.form.especificacoes = this.form.especificacoes.filter(row => row != especificacao)
      }else{
        this.form.especificacoes.push(especificacao)
      }
    },
    moduloIsChecked(codModulo){
      return this.form.modulos.some(cod => cod == codModulo)
    },
    especificacaoIsChecked(especificacao){
      return this.form.especificacoes.some(row => row == especificacao)
    },
    changeResponsavel(responsavel){
      this.form.responsavelCpf = responsavel.cpfCnpj
      this.form.contato = responsavel.cel ?? responsavel.tel
      this.form.idResponsavel = responsavel.idPessoa
    },
    loadVenda(){
      if(this.venda.idVenda){
        this.form.vendedor = this.venda.vendedor.razaoSocial ?? ''
        this.form.idVendedor = this.venda.vendedor.idPessoa
        this.form.cliente = this.venda.cliente.razaoSocial ?? ''
        this.form.idCliente = this.venda.cliente.idPessoa
        this.form.cpfCnpj = this.venda.cliente.cpfCnpj
        if(this.venda.cliente.cidade){
          this.form.cidade = `${this.venda.cliente.cidade.cidade} - ${this.venda.cliente.cidade.uf}`
          this.form.codCidade = this.venda.cliente.cidade.codCidade
          this.form.uf = this.venda.cliente.cidade.uf
        }
        if(this.venda.cliente.contador){
          this.form.contador = this.venda.cliente.contador.razaoSocial ?? ''
          this.form.idContador = this.venda.cliente.contador.idPessoa ?? null
        }

      }
    },

  },
}
</script>
